import classes from './menu.module.css'

const Menu = {
  classNames: {
    dropdown: classes.dropdown,
    item: classes.item,
    itemLabel: classes.itemLabel,
  },
}

export default Menu
